import { useEffect } from 'react'
import { AppRoutes } from './AppRoutes'
import { ToastProvider } from './context/ToastContext'
import useAuthStore from './store/auth-store'
import './index.css'

function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const sessionLogin = useAuthStore((s) => s.sessionLogin)

  // Cross-tab SSO: if this tab has no JWT yet but the user has logged in before
  // on this browser (the wq_remember_me flag is present), silently mint a token
  // from the shared Django session cookie. This keeps a NEW TAB logged in — even
  // at the root URL, which isn't a ProtectedRoute — without a second prompt.
  // Truly anonymous visitors (no flag) skip it, so public marketing pages make
  // no extra request. If the session is gone (e.g. non-remember after browser
  // close), the probe quietly fails and the normal login flow takes over.
  useEffect(() => {
    if (isAuthenticated) return
    let flag = null
    try { flag = localStorage.getItem('wq_remember_me') } catch (_e) { /* storage blocked */ }
    if (flag !== null) sessionLogin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  )
}

export default App
